var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2063 9.92471C19.8701 9.92471 20.1473 9.07178 19.608 8.67861L11.4031 2.71025C11.286 2.62441 11.1445 2.57812 10.9992 2.57812C10.854 2.57813 10.7125 2.62441 10.5953 2.71025L2.39045 8.67861C1.85119 9.06963 2.12834 9.92471 2.79436 9.92471H4.12424V17.9599H2.57736C2.48283 17.9599 2.40549 18.0372 2.40549 18.1317V19.2489C2.40549 19.3435 2.48283 19.4208 2.57736 19.4208H19.4211C19.5156 19.4208 19.593 19.3435 19.593 19.2489V18.1317C19.593 18.0372 19.5156 17.9599 19.4211 17.9599H17.8742V9.92471H19.2063ZM10.9992 4.2249L16.8237 8.46162H5.17482L10.9992 4.2249ZM5.67111 9.92471H8.18479V17.9599H5.67111V9.92471ZM9.73166 9.92471H12.2453V17.9599H9.73166V9.92471ZM16.3274 17.9599H13.7922V9.92471H16.3274V17.9599Z",
    fill: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankWhite);
export default __webpack_public_path__ + "static/media/bank-white.9e9f0738bc1bfdfdb06b0637f16d07cf.svg";
export { ForwardRef as ReactComponent };